module.exports = __webpack_public_path__ + "static/media/03d.d9d97549.png";